import React from 'react';
import { PRODUCT } from '../data/constants';
const FEATURES = ['Gasoline engine fundamentals & diagnostic process', 'Fuel delivery & fuel injection', 'Ignition & misfire diagnosis', 'Air intake, sensors & engine management', 'Emissions, VVT & drivability', 'Advanced testing & real-world diagnostic cases'];
export function SystemSection() {
  return <section className="bg-mist py-6 sm:py-9" data-id="element-169" data-mp="36m6d0w3r3cy5">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-170" data-mp="31lqvrtgcllaw">
        <h2 className="text-center text-[22px] leading-[1.05] text-navy sm:text-[36px]" data-id="element-171" data-mp="2wu0gra6gu9d5">
          The complete <span className="text-diag" data-id="element-172" data-mp="2ss5jcgrnog4n">6-in-1</span> gasoline engine
          diagnostic system
        </h2>

        <div className="mx-auto mt-4 max-w-[880px] rounded-md border-2 border-navy bg-white p-4 sm:p-6" data-id="element-173" data-mp="2ntu944xg83lw">
          <p className="text-center font-display text-[20px] font-bold uppercase leading-none text-navy sm:text-[28px]" data-id="element-174" data-mp="2iur60q1147gk">
            🔧 {PRODUCT}
          </p>
          <p className="mt-2 text-center font-display text-[12px] font-semibold uppercase tracking-[0.12em] text-diag sm:text-[15px]" data-id="element-175" data-mp="2dxh5ae86w9df">
            Understand • Diagnose • Test • Compare • Identify • Verify
          </p>
          <ul className="mt-4 grid gap-1.5 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-2" data-id="element-176" data-mp="u1ab8ri6azzy">
            {FEATURES.map(feature => <li key={feature} className="flex items-start gap-2" data-id="element-177" data-mp="yzbqt2ge4h6o">
                <span className="font-bold leading-snug text-diag" aria-hidden="true" data-id="element-178" data-mp="1mppll0qd0u4y">
                  ✔
                </span>
                <span className="text-[14px] font-semibold leading-snug text-navy sm:text-[16px]" data-id="element-179" data-mp="1rp27nj9epx6h">
                  {feature}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}